import { VStack } from '@ayble-health/dashboard-components';
import { Skeleton } from '@chakra-ui/react';

export const TasksColumnSkeleton = () => (
  <VStack gap={2} align="stretch" px={8}>
    {Array.from({ length: 5 }).map((_, i) => (
      <Skeleton key={i} height="89px" borderRadius="md" />
    ))}
  </VStack>
);
